import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-user-add',
    templateUrl: './user-add.component.html',
    styleUrls: ['./user-add.component.scss']
})
export class UserAddComponent implements OnInit {

    constructor(
        private http: HttpService,
        private el: ElementRef,
        private location: Location,
        public loading: LoadingService,
        private toastr: ToastrService) {
    }
    @ViewChild('theForm') theForm: NgForm | undefined;
    private apiPath = 'users';
    stayPage: boolean = false;
    formGroup = new FormGroup({
        name: new FormControl(null),
        email: new FormControl(null),
        password: new FormControl(null),
        status: new FormControl(1),
    });
    formChanged = false;

    submitForm(form: any): void {
        if (!form.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0]?.focus();
            return;
        }
        form.disable();
        this.http.Post(this.apiPath + '/create', form.value).then((r: any) => {
            form.enable();
            if (r.success) {
                this.toastr.success('Data saved successfully', 'Success');
                if (this.stayPage) {
                    form?.reset();
                    this.theForm?.resetForm();
                } else {
                    this.back();
                }
            } else {
                if (r.response && r.response.wrong) {
                    Object.keys(r.response.wrong).forEach((key) => {
                        if (key != 'id') {
                            form.get(key)?.setErrors({ serverError: r.response.wrong[key][0] });
                            this.el.nativeElement.querySelectorAll('[formcontrolname="' + key + '"]')?.[0]?.focus();
                        }
                    });
                }
            }
        });
    }

    back(): void {
        this.location.back();
    }

    canDeactivate(): Observable<boolean> | boolean {
        if (this.formChanged && (this.formGroup.valid && !this.theForm?.submitted)) {
            const result = window.confirm('There are unsaved changes! Are you sure?');
            return of(result);
        }
        return true;
    }

    ngOnInit(): void {
        const oldValue = this.formGroup.value;
        this.formGroup.valueChanges.subscribe((e: any) => {
            this.formChanged = (oldValue != e);
        });
    }
}
